import React from "react";
import CourseCard from "../CourseCard/CourseCard";

export default class MyCourses extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      courses: this.props.courses || [],
    };

    this.onRemove = this.onRemove.bind(this);
  }

  componentDidMount() {
    var self = this;
    var $my_course_list = $(this.refs.container);

    $my_course_list.sortable({
      axis: "y",
      handle: ".fa-bars",
      helper: "clone",
      selector: ".course-card-sortable",
      update: function () {
        var courses = [];
        var course_list = [];

        $my_course_list.find(".course-card-sortable").each(function () {
          var course_id = $(this).data("id");
          courses.push(self.findCourse(course_id));
          course_list.push(course_id);
        });

        self.setState({ courses: courses });

        $.ajax({
          type: "POST",
          url: "/reorder-my-courses",
          data: {
            account_id: $("#account_id").val(),
            course_ids: course_list,
            uid: $("#user_id").val(),
          },
        }).done(function (data) {
          //console.log('reorder-my-courses done', data);
        });
      },
    });

    if (typeof window.MyCoursesDidMount == "function") {
      window.MyCoursesDidMount();
    }
  }

  render() {
    var self = this;

    if (this.state.courses && this.state.courses.length > 0) {
      var courses = this.state.courses.map(function (course) {
        return (
          <CourseCard
            key={course.course_id}
            {...course}
            onRemove={self.onRemove}
            user_id={self.props.user_id}
            course_preview={self.props.course_preview}
            account={self.props.account}
          />
        );
      });

      return (
        <div className="my-courses" ref="container">
          {courses}
        </div>
      );
    } else {
      return (
        <div className="my-courses" ref="container">
          <div className="no-courses-jumbotron">
            <h2>{I18n.t("no_courses_message")}</h2>
            {this.props.account &&
            this.props.account.recommendation_survey_visible ? (
              <p>
                That's OK, enrolling is easy.
                <br />
                Just browse our library, ask for a recommendation, or search.
              </p>
            ) : (
              <p>
                That's OK, enrolling is easy.
                <br />
                Just browse our library or search.
              </p>
            )}
            <div className="buttons">
              <a href={this.props.browse_path} className="btn btn-primary">
                {I18n.t("browse_all_courses")}
              </a>
              {this.props.account &&
              this.props.account.recommendation_survey_visible ? (
                <a href={this.props.recommend_path} className="btn btn-primary">
                  Get recommendations
                </a>
              ) : null}
            </div>
          </div>
        </div>
      );
    }
  }

  onRemove(e) {
    e.preventDefault();
    e.stopPropagation();

    var confirmed = confirm(I18n.t("remove_from_my_courses_confirmation"));

    if (confirmed) {
      var course_id = $(e.target).data("id");
      var course_index = this.findCourseIndex(course_id);
      var courses = this.state.courses.slice(0);

      //console.log('confirmed lets remove', course_index);

      if (course_index >= 0) {
        courses.splice(course_index, 1);
      }

      this.setState({ courses: courses });

      $.ajax({
        type: "POST",
        url: this.props.remove_from_my_courses_path,
        data: {
          course_id: course_id,
        },
      }).done(function (data) {
        //console.log('onRemove done', data);
      });
    }
  }

  findCourse(id) {
    if (this.state.courses && this.state.courses.length) {
      for (var i = 0, ilen = this.state.courses.length; i < ilen; i++) {
        if (this.state.courses[i].course_id == id) {
          return this.state.courses[i];
        }
      }
    }
  }

  findCourseIndex(id) {
    if (this.state.courses && this.state.courses.length) {
      for (var i = 0, ilen = this.state.courses.length; i < ilen; i++) {
        if (this.state.courses[i].course_id == id) {
          return i;
        }
      }
    }
  }
}
